import { REPORT_TYPE_IDS } from '../../consts/reportTypes';

export const REPORT_TYPE_LABELS = {
  [REPORT_TYPE_IDS.AIF002]: 'AIF',
  [REPORT_TYPE_IDS.AIF001]: 'AIFM'
};
